import { render, staticRenderFns } from "./contentCourseLectureWebsite.vue?vue&type=template&id=b0faf828&"
import script from "./contentCourseLectureWebsite.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports